module.exports = __webpack_public_path__ + "img/05.01d1d647.png";